export default "__VITE_ASSET__85bee818__"